$( document ).ready(function() {

  // testimonial slider js
  
  $('.testimonial-slider').slick({
      infinite: true,
      arrow: false,
      centerMode:true,
      dots: true,
      centerPadding: "25%",
      loop: true,   
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
           responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 2,
                  centerPadding: "0%",
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
              },
               {
                breakpoint: 650,
                settings: {
                  slidesToShow: 1,
                  centerPadding: "0%",
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  centerPadding: "0%",
                  slidesToScroll: 1
                }
              }
          ]
   });
    // multiple column js
    $('.itg__slider_column').slick({
    infinite: true,
    arrow: true,
    dots: false,  
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="42" height="40" viewBox="0 0 42 40" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M0.749977 20C0.749977 30.604 9.69867 39.25 20.8 39.25C31.9013 39.25 40.85 30.604 40.85 20C40.85 9.39597 31.9013 0.75 20.8 0.75C9.69867 0.75 0.749977 9.39597 0.749977 20Z" stroke="#E0E0E0" stroke-width="1.5"/><path d="M23.787 12.213C24.071 12.497 24.071 12.9575 23.7869 13.2415L17.0285 19.9998L23.787 26.7585C24.071 27.0424 24.071 27.503 23.7869 27.787C23.5029 28.071 23.0424 28.071 22.7584 27.787L15.4857 20.5141C15.3493 20.3777 15.2727 20.1927 15.2727 19.9998C15.2727 19.807 15.3494 19.6219 15.4857 19.4856L22.7585 12.2131C23.0424 11.929 23.503 11.929 23.787 12.213Z" fill="#34383F"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="42" height="40" viewBox="0 0 42 40" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M40.85 20C40.85 30.604 31.9013 39.25 20.8 39.25C9.69869 39.25 0.75 30.604 0.75 20C0.75 9.39597 9.69869 0.75 20.8 0.75C31.9013 0.75 40.85 9.39597 40.85 20Z" stroke="#E0E0E0" stroke-width="1.5"/><path d="M17.813 12.213C17.529 12.497 17.5289 12.9575 17.813 13.2415L24.5715 19.9998L17.813 26.7585C17.529 27.0424 17.5289 27.503 17.813 27.787C18.097 28.071 18.5575 28.071 18.8415 27.787L26.1143 20.5141C26.2506 20.3777 26.3273 20.1927 26.3273 19.9998C26.3273 19.807 26.2506 19.6219 26.1142 19.4856L18.8415 12.2131C18.5575 11.929 18.097 11.929 17.813 12.213Z" fill="#34383F"/></svg></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
        responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
    
          ]
  });   


  
      $('.logos_slider').slick({
      infinite: true,
      arrow: false,
      dots: false,
      loop: true,   
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
           responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
    
          ]
    });

    if ($(window).width() < 1024) {
       $('.annocment_slider').slick({
      arrow: false,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      loop: false,   
      autoplay: false,
      prevArrow:'<button type="button" class="itg_arrow_annocment slick-prev pull-left"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13L1 7L7 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="itg_arrow_annocment slick-next pull-right"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 13L7 7L1 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
           responsive: [
              {
                breakpoint: 989,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
          ]
    });
    };

          if ($(window).width() < 1024) {
              $('.icon_text_slider').slick({
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    loop: false,   
                    autoplay: false,
                    responsive: [
                      {
                        breakpoint: 749,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                     }
                   ]
                }); 
            };


            if ($(window).width() < 1024) {
              $('.logolist_slider').slick({
                arrows: false,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                loop: true,   
                autoplay: true,
                responsive: [
                      {
                        breakpoint: 749,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2,
                          dots: true,
                        }
                     }
                   ]
                }); 
            };
    $('.btns_tabs').click(function(e) { 
      let $this = $(this);
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $('.btns_tabs svg').css("transform", "none");
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.btns_tabs svg').css("transform", "none");
          $this.parent().parent().find('.tabs_contents').removeClass('show');
           $this.closest('.tabs_text').find('svg').css("transform", "rotate(90deg)");
          $this.parent().parent().find('.tabs_contents').slideUp(350);
          $this.next().toggleClass('show'); 
          $this.next().slideToggle(350);
      }
    });
    // FAQ  section js 
      $('.faq_tabheadings').click(function(e) { 
      let $this = $(this);
         $('.faq_tabheadings').removeClass('active');
         $('.faq_tabheadings').removeClass('active-return'); 
         $this.addClass('active');
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $('.faq_tabheadings').removeClass("active");
           $this.addClass("active-return");
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.faq_text').removeClass('show');
          $this.parent().parent().find('.faq_text').slideUp(350);
          $this.next().toggleClass('show'); 
          $this.next().slideToggle(350);
      }  
    });  
//footer tab js
  if ($(window).width() < 768) {
  $('.footer_btns_tabs').click(function(e) { 
      let $this = $(this);
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $('.footer_btns_tabs svg').css("transform", "none");
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.footer_btns_tabs svg').css("transform", "none");
          $this.parent().parent().find('.footer_tabs_contents').removeClass('show');
           $this.closest('.footer-block').find('svg').css({"transform": "rotate(180deg)", "transition": "all 0.2s linear"});
          $this.parent().parent().find('.footer_tabs_contents').slideUp(350);
          $this.next().toggleClass('show'); 
          $this.next().slideToggle(350);
      }
    });
 };        
  $('.text-image-slider').slick({
      arrow: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false
  }); 

$('.onlyimage-slider').slick({
      arrow: false,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
        responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
   ]
  }); 
  // Counter To Count Number Visit jq codes //
        $(".counter").each(countUp);
        function countUp() {
          var num = $(this).text();
          var decimal = 0;
          if (num.indexOf(".") > 0) { // if number is Decimal
            decimal = num.toString().split(".")[1].length;
          }
          $(this)
            .prop("Counter", 0.0)
            .animate(
              {
                Counter: $(this).text()
              },
              {
                duration: 3000,
                easing: "swing",
                step: function (now) {
                  $(this).text(parseFloat(now).toFixed(decimal));
                }
              }
            );
        }
  // Counter To Count Number Visit jq codes //
  // menu week page ingredient js
  $('.itg_ingredients').click(function(event){
   event.preventDefault();
    $('.itg_menu_week_main').removeClass('active')
     $(this).closest('.itg_menu_week_main').addClass('active')
    $('.itg_ingredients_details').removeClass('active').fadeOut();
    $(this).closest('.itg_product_detail').find('.itg_ingredients_details').addClass('active').fadeIn();
    $('body').addClass('overflow-hidden ingradiant_active');
  });
   $('.itg_ingredient_close svg').click(function(){
        $('.itg_menu_week_main').removeClass('active')
     $('.itg_ingredients_details').removeClass('active').fadeOut();
     $('body').removeClass('overflow-hidden');
  });

$(document).on("click",".rc-widget input#rc-radio1",function() {
   var ths_first = $('#selling_plan').find(":selected").val();
   $('.itg_add-Ons').attr('data-bundle',ths_first);
   $(document).find(".itg_checkSub").attr('data-check',1);
});
$(document).on("click",".rc-widget input#rc-radio2",function() {
   var ths_two = 0;
   $('.itg_add-Ons').attr('data-bundle',ths_two);
   $(document).find(".itg_checkSub").attr('data-check',0);
});
$(document).on("click",".checkoutMethod",function() {
 var activemethod = $(this).find('.checkoutMethodName').html();
//alert(activemethod);
    $('.itg_cart .Note.caption.sub-heading').hide();
  if(activemethod == 'Store Pickup'){
  $(document).find('.LocalPickup').show();  
  }else if(activemethod == 'Local Delivery'){
      $(document).find('.Local_Home_Delivery').show();  
  }else{
     $(document).find('.Shipping_Text').show();  
  }
});


const productId = Number(document.querySelector('.product_page')?.getAttribute('data-id'));

function getAddonItems() {
  const items = [];

  $('.itg_add-Ons .quantity__input').each(function () {
    const qty = parseInt($(this).val(), 10) || 0;

    if (qty <= 0) return;

    const $parent = $(this).closest('.addons_item');

    const item = {
      id: $(this).data('varid'),
      quantity: qty
    };

    const sellingPlan = $parent.find('.esb-crossell-plan-select').val();

    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    items.push(item);
  });

  return items;
}

function resetAddonUI($btn) {
  setTimeout(() => {
    $('.itg_add-Ons').fadeOut();
    $('body').removeClass('overflow-hidden');

    $btn.text('Add to Cart').prop('disabled', false);
  }, 1500);
}

$(document).on('click', '#itg_btn_addons', function () {

  const items = getAddonItems();
  const $btn = $(this);

  if (!items.length) return;

  $btn.text('Loading...').prop('disabled', true);

  if (productId === 8340982595874) {

    const cart = document.querySelector('cart-drawer');
    const formData = new FormData();

    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);

      if (item.selling_plan) {
        formData.append(`items[${index}][selling_plan]`, item.selling_plan);
      }
    });

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id).join(',')
      );

      formData.append('sections_url', window.location.pathname);

      cart.setActiveElement(document.activeElement);
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',

      success: function (response) {

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }

        resetAddonUI($btn);
      },

      error: function (err) {
        console.log('Add failed', err);

        $btn.text('Add to Cart').prop('disabled', false);
      }
    });

    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: items
    },
    dataType: 'json',

    success: function () {

      $('.product-form__submit').trigger('click');

      resetAddonUI($btn);
    },

    error: function (err) {
      console.log('Add failed', err);

      $btn.text('Add to Cart').prop('disabled', false);
    }
  });

});

$(document).on('input change', '.itg_add-Ons .quantity__input', function () {
  
  let hasQty = false;

  $('.itg_add-Ons .quantity__input').each(function () {
    const qty = parseInt($(this).val(), 10) || 0;

    if (qty > 0) {
      hasQty = true;
      return false;
    }
  });

  const $btn = $('#itg_btn_addons');

  if ($btn.length) {
    if (hasQty) {
      $btn.removeClass('disabled').prop('disabled', false);
    } else {
      $btn.addClass('disabled').prop('disabled', true);
    }
  }

});

 if($(document).find('.cart-item[data-product-name="fit-flavors"]').length){
    var count_cart = $('.totle_item_count').attr('data-totlecount');
    if(count_cart > 1){
      var name = $(document).find('.cart-item[data-product-name="fit-flavors"] .product-option dd').text();
      var id = $(document).find('.cart-item[data-product-name="fit-flavors"]').attr('data-id');
      var qty = $(document).find('.cart-item[data-product-name="fit-flavors"]').attr('data-qty');
      var getvariant_id = $(document).find('select.copy-of-fit-flavors option[title="'+name+'"]').attr('value');
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: id,
          quantity: 0,
        },
      }).then((data) => {
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: "json",
          data: {
            id: getvariant_id,
            quantity: qty,
          },
        }).then((data) => {
            location.reload(true);
        });
      });
    } 
  }

  //remove product 
    if($(document).find('.cart-item[data-product-name="copy-of-fit-flavors"]').length){
    var count_cart = $('.totle_item_count').attr('data-totlecount');
    if(count_cart == 1){
      var name = $(document).find('.cart-item[data-product-name="copy-of-fit-flavors"] .product-option dd').text();
      var id = $(document).find('.cart-item[data-product-name="copy-of-fit-flavors"]').attr('data-id');
      var qty = $(document).find('.cart-item[data-product-name="copy-of-fit-flavors"]').attr('data-qty');
      var getvariant_id = $(document).find('select.fit-flavors option[title="'+name+'"]').attr('value');
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: id,
          quantity: 0,
        },
      }).then((data) => {
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: "json",
          data: {
            id: getvariant_id,
            quantity: qty,
          },
        }).then((data) => {
            location.reload(true);
        });
      });
    } 
  }

  $('.BtnProductNext').click(function(){
    $('.itg_add-Ons').fadeIn();
    $('body').addClass('overflow-hidden');
  });
  $('.BtnProductPrev').click(function(){
    if(productId == 8340982595874){
      $.ajax({
        url: '/?id=CartDrawer',
        method: "GET",
        dataType: "html",
      })
      .done(function (responseText) {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        var sliderElement = $(responseHTML).find("#CartDrawer").prop("innerHTML");
        $(document).find('#CartDrawer').html(sliderElement);
        $('cart-drawer').addClass('active');
        $('cart-drawer').addClass('animate');
        if($('cart-drawer').hasClass('is-empty')) {
          $('cart-drawer').removeClass('is-empty');
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {});
    } else {
      $(document).find('.product-form__submit').trigger('click');
    }
    setTimeout(function(){
      $('.itg_add-Ons').fadeOut();
    }, 1000); 
  })
 }); 



// checkout Button Check Delivery Fields

$(document).ready(function(){
 function checkDelivery(){
   var checkPickup = $(document).find('#storePickupApp'); 
   var checkDate = $(document).find('.checkoutMethodContainer.pickup').find('#Zapiet-InputCalendar__pickup');
   var checkShipping = $(document).find('.checkoutMethodContainer.shipping').find('#Zapiet-InputCalendar__shipping');
   var checkDeliveryDate = $(document).find('.checkoutMethodContainer.delivery').find('#Zapiet-InputCalendar__delivery');
   if(checkPickup){
     if(!checkDate.val() == '' || !checkShipping.val() == '' || !checkDeliveryDate.val() == ''){
      
       $(document).find('.btn_overlay').removeClass('active');
       $(document).find('.warning_message').removeClass('active');
     }else{
       $(document).find('.btn_overlay').addClass('active');
       $(document).find('.warning_message').addClass('active');
     }
   }
 } 
 $(document).on('click','.Zapiet-Calendar__Wrapper .picker__day',function(){
   setTimeout(function(){
  checkDelivery();
   },500);
 });
  $(document).on('click','.checkoutMethod',function(){
  setTimeout(function(){
  checkDelivery();
  },500);
 });
  $(document).on('click','span.btn_overlay.active',function(){
    $(document).find('.warning_message').addClass('active');
  });
});